import React from "react";
import PropTypes from "prop-types";
import { Grid, Container, Button, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";

import StarringYouCards from "components/StarringYouCards";
import Placeholder from "components/Placeholder";

import useStyles from "./useStyles";

const StarringYou = ({ items, loading, content }) => {
  const classes = useStyles();

  const renderTitle = () => {
    if (loading)
      return (
        <Typography variant="h2" className={classes.placeholder}>
          <Placeholder variant="text" height={50} />
        </Typography>
      );
    return (
      <Typography variant="h2" align="center" className={classes.title}>
        {content?.sectionSubHeaderText}
      </Typography>
    );
  };

  const renderButton = () => {
    const url = loading || !content?.viewMoreUrl ? "/" : content.viewMoreUrl;

    return (
      <Button id="home-video-ecards-view-more" component={NavLink} variant="outlined" color="primary" to={url}>
        {content?.viewMoreText}
      </Button>
    );
  };

  return (
    <div className={classes.root}>
      <Container>{renderTitle()}</Container>

      <StarringYouCards items={items} title={null} loading={loading} />

      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item>{renderButton()}</Grid>
      </Grid>
    </div>
  );
};

StarringYou.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      attributes: PropTypes.shape({}),
    }),
  ),
  loading: PropTypes.bool,
  content: PropTypes.shape({
    viewMoreText: PropTypes.string,
    sectionHeaderText: PropTypes.string,
    sectionSubHeaderText: PropTypes.string,
    viewMoreUrl: PropTypes.string,
  }),
};

export default StarringYou;
